export default __webpack_public_path__ + "static/media/zero-grau-mais-es.a6b75737.png";